// Shared, generic UI strings reused across many pages/components.
// Prefer these ids over inventing a page-scoped one when the text is a
// generic action/state word with no page-specific meaning.
export default {
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.confirm': 'Confirm',
  'common.close': 'Close',
  'common.search': 'Search',
  'common.loading': 'Loading...',
  'common.processing': 'Processing...',
  'common.submit': 'Submit',
  'common.back': 'Back',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.upload': 'Upload',
  'common.download': 'Download',
  'common.downloadAll': 'Download all',
  'common.refresh': 'Refresh',
  'common.retry': 'Retry',
  'common.copy': 'Copy',
  'common.copied': 'Copied',
  'common.selectAll': 'Select all',
  'common.clear': 'Clear',
  'common.clearAll': 'Clear all',
  'common.apply': 'Apply',
  'common.reset': 'Reset',
  'common.filter': 'Filter',
  'common.sort': 'Sort',
  'common.export': 'Export',
  'common.import': 'Import',
  'common.preview': 'Preview',
  'common.view': 'View',
  'common.add': 'Add',
  'common.remove': 'Remove',
  'common.rename': 'Rename',
  'common.share': 'Share',
  'common.settings': 'Settings',
  'common.logout': 'Logout',
  'common.profile': 'Profile',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.ok': 'OK',
  'common.areYouSure': 'Are you sure?',
  'common.actionCannotBeUndone': 'This action cannot be undone.',
  'common.noData': 'No data',
  'common.noResultsFound': 'No results found',
  'common.somethingWentWrong': 'Something went wrong',
  'common.pleaseTryAgain': 'Please try again',
  'common.success': 'Success',
  'common.error': 'Error',
  'common.warning': 'Warning',
  'common.info': 'Info',
  'common.optional': 'Optional',
  'common.required': 'Required',
  'common.name': 'Name',
  'common.title': 'Title',
  'common.description': 'Description',
  'common.status': 'Status',
  'common.actions': 'Actions',
  'common.date': 'Date',
  'common.time': 'Time',
  'common.createdAt': 'Created',
  'common.updatedAt': 'Updated',
  'common.type': 'Type',
  'common.size': 'Size',
  'common.file': 'File',
  'common.folder': 'Folder',
  'common.files': 'Files',
  'common.folders': 'Folders',
  'common.all': 'All',
  'common.none': 'None',
  'common.send': 'Send',
  'common.sending': 'Sending...',
  'common.new': 'New',
  'common.create': 'Create',
  'common.duplicate': 'Duplicate',
  'common.move': 'Move',
  'common.moveTo': 'Move to',
  'common.selectFile': 'Select file',
  'common.chooseFile': 'Choose file',
  'common.dragDropFilesHere': 'Drag and drop files here',
  'common.or': 'or',
  'common.browse': 'Browse',
  'common.continue': 'Continue',
  'common.skip': 'Skip',
  'common.done': 'Done',
  'common.finish': 'Finish',
  'common.start': 'Start',
  'common.stop': 'Stop',
  'common.pause': 'Pause',
  'common.resume': 'Resume',
  'common.enabled': 'Enabled',
  'common.disabled': 'Disabled',
  'common.active': 'Active',
  'common.inactive': 'Inactive',
  'common.draft': 'Draft',
  'common.published': 'Published',
  'common.archive': 'Archive',
  'common.unarchive': 'Unarchive',
  'common.favourite': 'Favourite',
  'common.favourites': 'Favourites',
  'common.pin': 'Pin',
  'common.unpin': 'Unpin',
  'common.expand': 'Expand',
  'common.collapse': 'Collapse',
  'common.showMore': 'Show more',
  'common.showLess': 'Show less',
  'common.language': 'Language',
  'common.darkMode': 'Dark mode',
  'common.lightMode': 'Light mode',
  'common.help': 'Help',
  'common.feedback': 'Feedback',
  'common.notifications': 'Notifications',
  'common.rows': 'Rows',
  'common.column': 'Column',
  'common.total': 'Total',
  'common.page': 'Page',
  'common.of': 'of',
  'common.notes': 'Notes',
};
